import { RequestStatus } from 'clickNgo/configs/service/common'
import { Operator } from 'core-components/types'

import { IPartnerSearchQueryParams } from '../../models/search'

import { IPartnerSearchState } from './models'

const initialFilters: IPartnerSearchQueryParams = {
  search: '',
  pagination: {
    partnersPage: 1,
    contactsPage: 1,
  },
  common: {
    market: '',
    isBusinessPartner: false,
    isDistributors: false,
    isRetailAmplify: false,
    isCommercial: false,
    isRetail: false,
    isCommercialAmplify: false,
    isMine: false,
    isBranchVisible: false,
  },
  partner: {
    partnerId: '',
    taxId: '',
    isLegal: false,
    communicationName: '',
    companyLegalName: '',
    country: '',
    legalCountry: '',
    state: '',
    legalState: '',
    city: '',
    legalCity: '',
    zipCode: '',
    legalZipCode: '',
    address: '',
    legalAddress: '',
    locationId: '',
    storeNumber: '',
    url: '',
    agreementNumber: '',
  },
  contact: {
    firstName: '',
    lastName: '',
    email: '',
    contactId: '',
    learnerId: '',
  },
}

export const initialState: IPartnerSearchState = {
  filters: initialFilters,
  highlightedWords: [],
  partners: {
    data: [],
    canLoadMore: true,
  },
  contacts: {
    data: [],
    canLoadMore: true,
  },
  isP360: false,
  message: '',
  status: RequestStatus.NONE,
  isElasticSearch: false,
}
